<script setup lang="ts" generic="TValue">
import { type RadioGroupProps, useRadioGroup } from "@formwerk/core";

const props = withDefaults(defineProps<RadioGroupProps<TValue> & { hideLabel?: boolean }>(), { hideLabel: false });
const { groupProps, labelProps, descriptionProps, errorMessageProps, errorMessage, isTouched } = useRadioGroup(props);
</script>

<template>
  <div v-bind="groupProps">
    <div v-bind="labelProps" :class="{ 'sr-only': hideLabel }">
      {{ label }}
    </div>
    <div class="flex flex-col gap-1.5">
      <slot />
    </div>
    <div v-if="isTouched && errorMessage" v-bind="errorMessageProps" class="text-sm text-danger">
      {{ errorMessage }}
    </div>
    <div v-if="description" v-bind="descriptionProps" class="text-sm text-muted">
      {{ description }}
    </div>
  </div>
</template>
